import React from "react";
import merge from "lodash/merge";
import {
  Config, Settings, 
  MuiConfig,
  Widgets,
  BasicConfig,
  CoreWidgets,
} from "@react-awesome-query-builder/mui";
import { createConfig } from "./config";
import { ruRU } from "@mui/material/locale";
import "@react-awesome-query-builder/mui/css/styles.scss";
import themeOptions from "app/components/MatxTheme/themeOptions";
import { TextField } from "@mui/material";

const configMixin = {
  settings: {
    locale: {
      mui: ruRU,
    },
    theme: {
      mui: themeOptions
    },
    customFieldSelectProps: {
      input: {
        // variant: "outlined",
      }
      
    },
    showErrorMessage: true,
    removeIncompleteRulesOnLoad: false

  } as Partial<Settings>,
};

const muiConfig: Config = createConfig({
  ...MuiConfig,
  widgets: {
    ...MuiConfig.widgets,
    text: {
      ...MuiConfig.widgets.text,
      customProps: {
        // variant: "outlined",
        size: "small",
      },
    },
    
    field: {
      ...MuiConfig.widgets.field,
      // @ts-ignore
      factory: (props) => null,
    },
    select: {
      ...MuiConfig.widgets.select,
      factory: (props) => null,

      customProps: {
        // variant: "outlined",
        size: "small",
      }
    },
    treeselect: {
      ...MuiConfig.widgets.treeselect,
      factory: (props) => null,
    },
  }
});

const config: Config = merge( {}, muiConfig, configMixin );

export default config;